import { customToast } from "../../../../shared";
import { brandReportService } from "../../services/brandReport.service";
import { GET_BRAND_REPORT, toastTypes } from "../../constants";
import {
  withSpinner,
  success,
  failure,
} from "../../../../redux/actions/utilities";
import { errorMessages } from "../../../../constants/toastMessages/toastMessages.constants";

const getBrandReport = (body) => (dispatch) => {
  return withSpinner(dispatch, GET_BRAND_REPORT, () =>
    brandReportService
      .getSurveyReportForPOSAndOnlineStores(body)
      .then(
        (response) => {
          dispatch(success(response, GET_BRAND_REPORT));
          return response;
        },
        (error) => {
          customToast(
            errorMessages.BRAND_REPORT_FETCH_FAILED,
            toastTypes.ERROR
          );
          dispatch(
            failure([errorMessages.BRAND_REPORT_FETCH_FAILED], GET_BRAND_REPORT)
          );
        }
      )
  );
};

const clearBrandReport = () => (dispatch) => {
  dispatch(failure([errorMessages.BRAND_REPORT_FETCH_FAILED], GET_BRAND_REPORT));
};

export const brandReportActions = {
  getBrandReport,
  clearBrandReport,
};
export { GET_BRAND_REPORT };
